import { sessionFreshen } from '@/api/session/sessionFreshen'
import { sessionEnd } from '@/api/session/sessionEnd'
import { useApi } from '@/hooks/useApi'
import { clearGlobalState } from '@/utilities/createGlobalState'
import { routes } from '@/utilities/routes'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTenantId } from '@/hooks/useTenantId'

export function LogOutPage() {

  const tenantId = useTenantId()
  const api = useApi()
  const navigate = useNavigate()

  useEffect(() => {
    async function fn() {
      try {
        await sessionEnd(api, tenantId)
      } finally {
        localStorage.removeItem('sessionId')
        clearGlobalState()
      }
      await sessionFreshen(api, tenantId)
      navigate(routes.logIn(tenantId))
    }
    fn()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount
  }, [])

  return <main>Logging out...</main>
}
